export const users: TableModule = {
    name: "users",
    route: "spa.users",
    defaultOrder: {
        column: "lastname|firstname",
        direction: "asc"
    },
    columns: [
        {
            name: "customName",
            sortable: true,
            sortBy: "lastname|firstname",
            mobile: true,
            width: "w-1/2 sm:w-auto"
        },
        {
            name: "email",
            sortable: true
        },
        {
            name: "role_name",
            sortable: true,
            mobile: true,
            width: "w-[150px]"
        },
        {
            name: "organisations",
            breakpoint: "md"
        },
        {
            name: "active",
            sortable: true,
            width: "w-[200px]"
        }
    ],
    filters: [
        {
            name: "email",
            column: "users.email",
            type: "string",
            reduced: "like"
        },
        {
            name: "role",
            column: "users.role_name",
            type: "select",
            options: [
                {
                    value: "system",
                    label: "users.attributes.roles.system"
                }, {
                    value: "sport_admin",
                    label: "users.attributes.roles.sport_admin"
                }, {
                    value: "organisation_admin",
                    label: "users.attributes.roles.organisation_admin"
                }, {
                    value: "team_admin",
                    label: "users.attributes.roles.team_admin"
                }, {
                    value: "referee",
                    label: "users.attributes.roles.referee"
                }
            ],
            reduced: true
        },
        {
            name: "organisation",
            column: "organisations.id",
            type: "searchSelect",
            reduced: "in",
            relation: "organisations",
            spaRoute: "spa.organisations.index",
            additionalDisplayKey: "sport_name",
            searchThreshold: 1,
            searchSelectConfig: {
                fetchOnSearch: true,
            },
            ability: ["viewAny", "organisations"]
        }
    ],
    quickFilters: [
        {
            name: "fromOrganisationsWithRegistrations",
            column: "customFilterOrganisationsWithRegistrations",
            value: true,
            operator: "=",
            default: true,
        },
    ],
    tools: [
        {
            name: "users.delete",
            color: "rose",
            icon: "delete"
        },
        {
            name: "users.create",
            isCreateAction: true,
            ability: [
                "create",
                "users"
            ]
        }
    ]
}